export default "__VITE_ASSET__Cr_fz6Ss__"